import { Box, Button, Container, IconButton, Modal, TextField, Typography } from '@mui/material';
import React, { useRef, useState, useEffect } from 'react';
import icall1 from "../Images/icall1.png";
import icall4 from "../Images/about1.png"
import preview1 from "../Images/ss 1.png";
import preview3 from "../Images/ss2.png";
import preview4 from "../Images/ss3.png";
import preview5 from "../Images/ss4.png";
import preview6 from "../Images/ss5.png";
import preview7 from "../Images/ss6.png";
import preview8 from "../Images/ss7.png";
import preview9 from "../Images/ss8.png";
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import Upbutton from '../upbutton/Upbutton';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import Loader from '../Loader/Loader';
import { FaArrowRightLong } from "react-icons/fa6";
import backgroundimg from '../Images/herowallpaper2.jpg'
import herobg1 from '../Images/herobg1.png';
import herobg2 from '../Images/herobg2.png';
import herobg3 from '../Images/herobg3.png';
import herobg4 from '../Images/herobg4.png';
import herobg5 from '../Images/herobg5.png';
import herobg6 from '../Images/herobg6.png';
import herobg7 from '../Images/herobg7.png';
import herobg8 from '../Images/herobg8.png';
import herobg9 from '../Images/herobg9.png';
import herobg10 from '../Images/herobg10.png';
import herobg11 from '../Images/herobg11.png';
import herobg12 from '../Images/herobg12.png';
import side3 from "../Images/callicon.png";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Helmet } from 'react-helmet';
import Featureicon1 from '../Images/featureicon1.png';
import Featureicon2 from '../Images/featureicon2.png';
import Featureicon3 from '../Images/featureicon3.png';
import Featureicon4 from '../Images/featureicon4.png';
import Featureicon5 from '../Images/featureicon5.png';
import Featureicon6 from '../Images/featureicon6.png';
import Featureicon7 from '../Images/featureicon7.png';
import Featureicon8 from '../Images/featureicon8.png';
import { GrCaretNext, GrCaretPrevious } from "react-icons/gr";


const images = [
    {
        title: "Fake Call",
        subtitle: "Simulate incoming calls to escape awkward situations, get out of meetings, or prank friends with realistic call screens.",
        sideimg: herobg1,
    },
    {
        title: "Caller Wallpaper",
        subtitle: "Customize your call screen with beautiful HD wallpapers. Make every call feel personal with a stylish and user-friendly interface.",
        sideimg: herobg2,
    },
    {
        title: "Caller Button Style",
        subtitle: "Choose from a wide range of modern and intuitive button styles to personalize your dialer experience.",
        sideimg: herobg3,
    },
    {
        title: "Flash on Call",
        subtitle: "Never miss an incoming call with LED flash alerts, especially useful in noisy environments or silent mode.",
        sideimg: herobg4,
    },
    {
        title: "Dynamic Ringtones",
        subtitle: "Assign unique and fun ringtones to your favorite contacts or groups to identify callers instantly without checking your phone.",
        sideimg: herobg5,
    },
    {
        title: "Call Back Screen",
        subtitle: "Revamp your call back screen with advanced themes and smart layouts for a more engaging calling experience.",
        sideimg: herobg6,
    },
    {
        title: "Backup Contacts",
        subtitle: "Easily back up your contacts to the cloud and restore them anytime to any device — secure and effortless.",
        sideimg: herobg7,
    },
    {
        title: "Keypad Sound",
        subtitle: "Enable and customize keypad tones for a tactile and satisfying dialing experience tailored to your preferences.",
        sideimg: herobg8,
    },
    {
        title: "Call Blocker",
        subtitle: "Block spam and unwanted calls with a powerful call blocking feature that keeps your communication safe and smooth.",
        sideimg: herobg9,
    },
    {
        title: "Quick Response",
        subtitle: "Send instant, predefined SMS replies when you're unavailable to answer — stay polite even when you're busy.",
        sideimg: herobg10,
    },
    {
        title: "Dark Mode",
        subtitle: "Switch to dark mode for a sleek look that reduces eye strain and saves battery life, especially at night.",
        sideimg: herobg11,
    },
    {
        title: "Call Announcer",
        subtitle: "Stay hands-free and informed with caller name announcements, perfect for when you're driving or multitasking.",
        sideimg: herobg12,
    },
];


const Icallphone = () => {
    const [open, setOpen] = useState(false);
    const [activeImage, setActiveImage] = useState(null);
    const scrollRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
        }, 5000);

        return () => clearInterval(interval);
    }, [currentIndex]);

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    useEffect(() => {
        Aos.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
        });
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    const cardData = [
        {
            title: 'Fake Call',
            description: 'Trigger a fake call for quick exits. Customize caller name and call log.',
            img: Featureicon1,
            color: '#e53935',
        },
        {
            title: 'Caller Wallpaper',
            description: 'Customize your caller screen with vibrant wallpapers. Set images for contacts or groups.',
            img: Featureicon2,
            color: '#1976d2',
        },
        {
            title: 'Caller Button',
            description: 'Record important calls with ease. Enable or disable anytime from settings.',
            img: Featureicon3,
            color: '#d32f2f',
        },
        {
            title: 'Dynamic Ringtones',
            description: 'Set different ringtones for each contact. Enjoy a more personalized call experience.',
            img: Featureicon4,
            color: '#8e24aa',
        },
        {
            title: 'Flash on Call',
            description: 'Enable flash alerts for incoming calls. Great for silent mode or noisy places.',
            img: Featureicon5,
            color: '#f9a825',
        },
        {
            title: 'Call Back Screen',
            description: 'Manage calls with tools like blocking and voicemail. Streamline your communication.',
            img: Featureicon6,
            color: '#d81b60',
        },
        {
            title: 'Backup Contact',
            description: 'Silence calls and alerts when needed. Perfect for focused or rest time.',
            img: Featureicon7,
            color: '#6d4c41',
        },
        {
            title: 'Dark Mode',
            description: 'Switch to dark theme for night use. Reduce eye strain and save battery.',
            img: Featureicon8,
            color: '#263238',
        }

    ];
    const screenshots = [
        { img: preview1 },
        { img: preview3 },
        { img: preview4 },
        { img: preview5 },
        { img: preview6 },
        { img: preview7 },
        { img: preview8 },
        { img: preview9 },
    ];
    const handleOpen = (img) => {
        setActiveImage(img);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setActiveImage(null);
    };
    const scroll = (direction) => {
        const scrollAmount = 250;
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };
    if (loading) {
        return (
            <div className="App">
                <Loader />
            </div>
        );
    }
    return (
        <Box>
            <Helmet>
                <title>iCall Phone Dialer & Contacts</title>
            </Helmet>
            {/* ======== header ======= */}
            <Box>
                <Header />
            </Box>
            <Box sx={{ height: { xs: '56px', sm: '70px' } }} />
            {/* ======= home sections ====== */}
            <Box>
                <Box sx={{
                    position: 'relative',
                    height: '100vh',
                    width: '100%',
                    minHeight: '600px',
                    backgroundImage: `url(${backgroundimg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}>
                    {images.map((img, index) => (
                        <Box
                            key={index}
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundImage: `url(${img.url})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                transition: 'opacity 1s ease-in-out',
                                opacity: index === currentIndex ? 1 : 0,
                                zIndex: index === currentIndex ? 1 : 0,
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    bgcolor: 'rgba(0, 0, 0, 0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Container maxWidth="xl">
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            gap: "30px",
                                            textAlign: { xs: 'center', md: 'start' },
                                            justifyContent: 'space-between',
                                            paddingTop: { md: '100px', sm: '60px', xs: '30px' },
                                        }}
                                    >
                                        <Box sx={{ width: { md: 'calc(50% - 15px)', xs: '100%' } }}>
                                            <Box sx={{ width: { md: "20%", xs: '60%' }, margin: '0 auto', display: { md: "none", xs: 'block' } }}>
                                                <img src={img.sideimg} alt="" width={'100%'} />
                                            </Box>
                                            <Box sx={{ width: "15%", display: { md: "block", xs: 'none' } }}>
                                                <img src={side3} alt="" width={'100%'} />
                                            </Box>
                                            <Typography
                                                variant="h3"
                                                gutterBottom
                                                sx={{
                                                    fontWeight: 700,
                                                    color: '#fff',
                                                    fontSize: { xs: '20px', sm: '30px', md: '40px' },
                                                    mb: 2,
                                                    mt: 2,
                                                }}
                                            >
                                                {img.title}
                                            </Typography>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    maxWidth: { md: "500px", xs: '100%' },
                                                    color: '#ccc',
                                                    fontSize: { xs: '14px', sm: '16px' },
                                                    lineHeight: 1.7,
                                                    mb: 3,
                                                }}
                                                paragraph
                                            >
                                                {img.subtitle}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    width: { xs: '60%', sm: '30%', md: '40%' },
                                                    margin: { md: "24px 0px", xs: "24px auto" },
                                                    transition: '0.3s',
                                                    '&:hover': {
                                                        transform: 'scale(1.05)',
                                                    }
                                                }}
                                            >
                                                <a
                                                    href="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        src={icall1}
                                                        alt="Get iCall on Google Play"
                                                        width="100%"
                                                    />
                                                </a>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                width: { md: 'calc(50% - 15px)', xs: '100%' },
                                                display: { md: 'block', xs: 'none' },
                                            }}
                                        >
                                            <Box sx={{ width: '70%', margin: "0 auto" }}>
                                                <img
                                                    src={img.sideimg}
                                                    alt={img.title}
                                                    style={{ width: '100%', borderRadius: 12 }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                </Container>
                            </Box>
                        </Box>
                    ))}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: 0,
                            right: 0,
                            display: { md: 'flex', xs: 'none' },
                            justifyContent: 'space-between',
                            px: 2,
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                        }}
                    >
                        <IconButton onClick={handlePrev} sx={{ color: 'white', width: 48, height: 48 }}>
                            <ArrowBackIosNewIcon fontSize="medium" />
                        </IconButton>
                        <IconButton onClick={handleNext} sx={{ color: 'white', width: 48, height: 48 }}>
                            <ArrowForwardIosIcon fontSize="medium" />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            {/* ====== about parts ===== */}
            <Box data-aos="fade-up" sx={{ paddingTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Container maxWidth="xl">
                    {/* Title */}
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{ fontSize: { md: '42px', sm: '30px', xs: '24px' } }}
                    >
                        About Us
                    </Typography>
                    <Typography
                        className='maindescption'
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            margin: '0px auto',
                            maxWidth: 700,
                            mt: 2,
                        }}
                    >
                        iCall is a fast, smart dialer and contacts app that makes calling simple and seamless.iCall is a fast, smart dialer and contacts app that makes calling simple and seamless.
                    </Typography>

                    {/* Content Wrapper */}
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            marginTop: { md: '50px', xs: '30px' },
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        {/* Image Section */}
                        <Box
                            sx={{
                                width: { xs: '100%', md: 'calc(40% - 10px)' },
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <Box className='imageanimations' sx={{ width: '70%' }}>
                                <img
                                    src={icall4}
                                    alt="iCall App Preview"
                                    style={{ width: '100%', height: '100%', display: 'block', margin: '0px auto' }}
                                />
                            </Box>
                        </Box>

                        {/* Text Section */}
                        <Box
                            sx={{ width: { xs: '100%', md: 'calc(60% - 10px)' } }}>
                            <Typography
                                className='sectionheading'
                                variant="h4"
                                sx={{ fontSize: { md: '40px', sm: '30px', xs: '24px' } }}
                            >
                                iCall Phone Dialer & Contacts
                            </Typography>

                            <Typography
                                className='sectiondescption'
                                variant="body1"
                                sx={{
                                    marginTop: '16px',
                                    textAlign: 'justify',
                                }}
                            >
                                iCall is a free, fast, and secure dialer app that helps you make calls,
                                send messages, and manage your contacts. With iCall, you can easily find
                                and call your contacts, and also block unwanted calls and messages.
                                <br /><br />
                                Our app is designed for a seamless user experience with a simple,
                                intuitive interface. We value your privacy — your data is never collected
                                or stored.
                            </Typography>

                            {/* Button */}
                            <Box sx={{ marginTop: { md: '20px', xs: '16px' } }}>
                                <Button
                                    sx={{
                                        padding: '10px 30px',
                                        backgroundColor: 'rgb(64, 153, 247)',
                                        color: '#fff',
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        transition: '1s',
                                        '&:hover': {
                                            backgroundColor: '#000',
                                            transform: 'translatex(15px)',
                                        },
                                    }}
                                >
                                    <Link to="/about" style={{ color: '#fff', textDecoration: 'none' }}>
                                        Learn More
                                    </Link>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
            {/* ======== feature section =========== */}
            <Box data-aos="fade-up" sx={{
                marginTop: { md: '100px', sm: '60px', xs: '30px' }, backgroundColor: '#f4f6f8',
            }}>
                <Container maxWidth="xl">
                    <Box sx={{ padding: { md: "50px 0px", xs: '30px 0px' } }}>
                        <Typography className='mainheading'
                            variant="h4"
                            sx={{
                                fontSize: { md: '42px', sm: '30px', xs: '24px' }
                            }}
                        >
                            Features
                        </Typography>
                        <Typography
                            className='maindescption'
                            variant="body1"
                            sx={{
                                textAlign: 'center',
                                margin: '0px auto',
                                maxWidth: 700,
                                mt: 2,
                            }}
                        >
                            iCall is a fast, lightweight, and intelligent phone dialer and contact manager designed to make calling effortless
                        </Typography>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                mt: { md: '50px', xs: '30px' },
                                justifyContent: 'center',
                            }}
                        >
                            {cardData.map((card, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        flex: {
                                            xs: '1 1 100%',
                                            sm: '1 1 calc(50% - 10px)',
                                            md: '1 1 calc(33.33% - 14px)',
                                            lg: '1 1 calc(25% - 15px)',
                                        },
                                        maxWidth: {
                                            xs: '100%',
                                            sm: 'calc(50% - 10px)',
                                            md: 'calc(33.33% - 14px)',
                                            lg: 'calc(25% - 15px)',
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            padding: '20px',
                                            backgroundColor: '#ffffff',
                                            height: { md: '300px', xs: 'auto' },
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            '&:hover': {
                                                transform: 'translateY(-5px)',
                                                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                                            },
                                        }}
                                    >
                                        <Box sx={{ width: "25%", overflow: "hidden", }}>
                                            <img
                                                src={card.img}
                                                alt={card.title}
                                                width={'100%'}
                                                style={{
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </Box>
                                        <Typography
                                            className='cardlooptitle'
                                            variant="h5"
                                            sx={{
                                                mt: 1,
                                                fontSize: { md: '18px', xs: '16px' }
                                            }}
                                        >
                                            {card.title}
                                        </Typography>

                                        <Typography className='cardloopdesc' variant="body1">
                                            {card.description}
                                        </Typography>
                                        <Box>
                                            <Button
                                                component={Link}
                                                to='https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook'
                                                sx={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    color: 'rgb(64, 153, 247)',
                                                    textTransform: 'none',
                                                    fontWeight: 500,
                                                    fontSize: { md: '16px', xs: '14px' },
                                                    transition: '0.4s ease',
                                                    '&:hover': {
                                                        transform: 'translatex(10px)',
                                                        backgroundColor: 'transparent',
                                                    }
                                                }}
                                            >
                                                Download Now
                                                <FaArrowRightLong
                                                    sx={{
                                                        fontSize: '16px',
                                                        color: 'rgb(64, 153, 247)',
                                                    }}
                                                />
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Container>
            </Box>
            {/* ======== App preview ==== */}
            <Box>
                <Box sx={{ padding: { md: "50px 0px", xs: '30px 0px' }, backgroundColor: '#f4f6f8' }}>
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{
                            fontSize: { md: '42px', sm: '30px', xs: '24px' }
                            // padding: 2
                        }}
                    >
                        App Preview
                    </Typography>
                    <Typography
                        className='maindescption'
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            margin: '0px auto',
                            maxWidth: 700,
                            mb: { md: 3, xs: 1 },
                            padding: 2
                        }}
                    >
                        Explore how iCall looks and feels in action. This is a live preview of the app. You can interact with the app to see how it works.
                    </Typography>
                    <Box sx={{ position: 'relative', mt: 4 }}>
                        <Box
                            ref={scrollRef}
                            sx={{
                                display: 'flex',
                                overflowX: 'auto',
                                scrollbarWidth: 'none',
                                '&::-webkit-scrollbar': { display: 'none' },
                                gap: 2,
                                padding: 2,
                                scrollBehavior: 'smooth',
                            }}
                        >
                            {screenshots.map((screenshot, index) => (
                                <Box key={index} sx={{ textAlign: 'center', width: "100%" }}>
                                    <Box
                                        component="img"
                                        loading="lazy"
                                        src={screenshot.img}
                                        alt={`Screenshot ${index + 1}`}
                                        onClick={() => handleOpen(screenshot.img)}
                                        sx={{
                                            height: { md: "320px", xs: "150px" },
                                            borderRadius: 2,
                                            boxShadow: 3,
                                            cursor: 'pointer',
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease-in-out',
                                            '&:hover': {
                                                transform: 'scale(1.02)',
                                            },
                                        }}
                                    />
                                    {screenshot.caption && (
                                        <Typography
                                            variant="caption"
                                            sx={{ display: 'block', mt: 1, color: '#6b6b6b' }}
                                        >
                                            {screenshot.caption}
                                        </Typography>
                                    )}
                                </Box>
                            ))}
                        </Box>
                        <IconButton
                            onClick={() => scroll('left')}
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                width: 50,
                                height: 50,
                                left: 10,
                                transform: 'translateY(-50%)',
                                backgroundColor: '#ffffffcc',
                                zIndex: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                borderRadius: '50%',
                                color: '#000',
                                display: { md: 'flex', xs: 'none' },
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#4099F7',
                                    color: '#fff',
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.6)',
                                    transform: 'translateY(-50%) scale(1.1)',
                                },
                            }}
                        >
                            <GrCaretPrevious style={{ fontSize: '20px' }} />
                        </IconButton>

                        <IconButton
                            onClick={() => scroll('right')}
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                width: 50,
                                height: 50,
                                right: 10,
                                transform: 'translateY(-50%)',
                                backgroundColor: '#ffffffcc',
                                zIndex: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                borderRadius: '50%',
                                color: '#000',
                                display: { md: 'flex', xs: 'none' },
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#4099F7',
                                    color: '#fff',
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.6)',
                                    transform: 'translateY(-50%) scale(1.1)',
                                },
                            }}
                        >
                            <GrCaretNext style={{ fontSize: '20px' }} />
                        </IconButton>
                    </Box>
                    <Modal open={open} onClose={handleClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Box
                            sx={{
                                position: 'relative',
                                bgcolor: 'background.paper',
                                boxShadow: 24,
                                p: 2,
                                outline: 'none',
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                borderRadius: 2,
                            }}
                        >
                            <IconButton
                                onClick={handleClose}
                                sx={{ position: 'absolute', top: 8, right: 8, color: 'grey.700' }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <Box
                                component="img"
                                src={activeImage}
                                alt="Preview"
                                sx={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                            />
                        </Box>
                    </Modal>
                </Box>
            </Box>
            {/* ========= contact us ========= */}
            <Box data-aos="fade-up" sx={{ paddingTop: { md: '100px', sm: '60px', xs: '30px' } }
            }>
                <Container maxWidth="xl">
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{
                            fontSize: { md: '42px', sm: '30px', xs: '24px' }
                        }}
                    >
                        Contact Us
                    </Typography>
                    <Typography
                        className='maindescption'
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            margin: '0px auto',
                            maxWidth: 700,
                            mb: 4,
                        }}
                    >
                        iCall is a fast, smart dialer and contacts app that makes calling simple and seamless.
                    </Typography>

                    <Box
                        component="form"
                        noValidate
                        autoComplete="off"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            p: { xs: 2, md: 4 },
                            backgroundColor: '#f9f9f9',
                            borderRadius: 2,
                            // boxShadow: 3,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                gap: 2,
                            }}
                        >
                            <TextField
                                fullWidth
                                label="Your Name"
                                variant="outlined"
                                name="name"
                            />
                            <TextField
                                fullWidth
                                label="Your Email"
                                variant="outlined"
                                type="email"
                                name="email"
                            />
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                gap: 2,
                            }}
                        >
                            <TextField
                                fullWidth
                                label="Your Phone"
                                variant="outlined"
                                type="tel"
                                name="phone"
                            />
                            <TextField
                                fullWidth
                                label="Subject"
                                variant="outlined"
                                name="subject"
                            />
                        </Box>

                        <TextField
                            fullWidth
                            label="Your Message"
                            variant="outlined"
                            multiline
                            rows={4}
                            name="message"
                        />

                        <Box sx={{ textAlign: 'center', mt: 2 }}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    padding: '10px 20px',
                                    fontWeight: 500,
                                    fontSize: '1rem',
                                    borderRadius: '10px',
                                    backgroundColor: 'rgb(64, 153, 247)',
                                    textTransform: 'none',
                                    transition: '1s',
                                    '&:hover': {
                                        backgroundColor: '#000',
                                        transform: 'translateY(-10px)',
                                    },
                                }}
                            >
                                Send Message
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Box>
            {/* ======= footer ===== */}
            <Box sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Footer />
            </Box>
            {/* ======= Uopbutton ===== */}
            <Box>
                <Upbutton />
            </Box>
        </Box>
    );
};
export default Icallphone;